export default __webpack_public_path__ + "static/media/fur.91d7beca.svg";